import React from "react";
import { Card, Avatar } from "antd";
import { useSelector } from "react-redux";
import { selectAuthInfo } from "../../Auth/authSelectors";

export default function WelcomeCard({data, isAdminUser}){
const auth = useSelector(selectAuthInfo);

const name = auth?.userInfo?.name || "User";
const first = name.charAt(0).toUpperCase();
const currentEmployeePhoto = data?.currentEmployee?.employee_photo_path;

const approvals = data.pendingRequests?.pending?.length || 0;
const leaves = data.pendingRequests?.pending?.filter(a => a.attendance.includes("leave"))?.length || 0;

return(

<Card className="welcome-card">

<div className="welcome-container">

<Avatar
  size={64}
  src={currentEmployeePhoto}
  className="welcome-avatar"
>
 {!currentEmployeePhoto && first}
</Avatar>

<div>

<h2>Welcome Back, {name}</h2>

{isAdminUser && <p>
You have <b>{approvals}</b> Pending Approvals
including <b> {leaves}</b> Leave Requests
</p>}

</div>

</div>

</Card>

);

}